(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2945],{

/***/ 43760:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[productid]/[crossreferenceid]",
      function () {
        return __webpack_require__(7474);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26626);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_withPage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68262);
/* harmony import */ var _src_components_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13366);
/* harmony import */ var _src_components_product_product_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74673);
/* harmony import */ var _src_redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89703);
/* harmony import */ var _src_redux_actions_geolocation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47571);
/* harmony import */ var _src_redux_actions_providerLocation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70620);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2962);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14416);








 //  Needed due to Next.JS Bug.... Forces HOC Wrap to avoid "The default export is not a React Component in page: "/product"""









//  Remove Product out of Redux Linking  Should be passed as a prop
var queryString = __webpack_require__(17563);
var ProductPage = /*#__PURE__*/ function(Page) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(ProductPage, Page);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(ProductPage);
    function ProductPage(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(this, ProductPage);
        return _super.call(this, props);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(ProductPage, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this = this;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
                    var categoryid;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!(prevProps.geolocation.latitude !== _this.props.geolocation.latitude || prevProps.geolocation.longitude !== _this.props.geolocation.longitude)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    _this.props.getProductData(_this.props.productid)
                                ];
                            case 1:
                                _state.sent();
                                if (!(_this.props.crossreferenceid != "undefined")) return [
                                    3,
                                    3
                                ];
                                categoryid = _this.props.fitmentTarget && _this.props.fitmentTarget.fullUrlSlug ? _this.props.fitmentTarget.fullUrlSlug : _this.props.crossreferenceid;
                                return [
                                    4,
                                    _this.props.getCategoryProps(categoryid)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    5
                                ];
                            case 3:
                                return [
                                    4,
                                    _this.props.getCategoryProps("")
                                ];
                            case 4:
                                _state.sent();
                                _state.label = 5;
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.router) {
                    this.props.setNavigation({
                        previousUrl: this.props.router.asPath
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var ref, ref1, ref2, ref3, ref4, ref5;
                var item = this.props.item;
                var title = "1-800-Battery";
                var hostname = "1800battery.com";
                if (true) {
                    hostname = window.location.hostname;
                }
                // console.log(this.props.router.asPath);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_7__/* .NextSeo */ .PB, {
                            title: "".concat(item === null || item === void 0 ? void 0 : (ref = item.brand) === null || ref === void 0 ? void 0 : ref.brandName, " ").concat(item === null || item === void 0 ? void 0 : item.name, " for ").concat(this.props.applicationLabel, " | ").concat(title, " "),
                            description: "".concat(item === null || item === void 0 ? void 0 : item.shortDescription, " in Your City."),
                            canonical: "https://".concat(hostname, "/product/").concat(this.props.router.query.productid),
                            openGraph: {
                                title: "".concat(item === null || item === void 0 ? void 0 : (ref1 = item.brand) === null || ref1 === void 0 ? void 0 : ref1.brandName, " ").concat(item === null || item === void 0 ? void 0 : item.name, " for ").concat(this.props.applicationLabel, " | ").concat(title),
                                description: "".concat(item === null || item === void 0 ? void 0 : item.shortDescription, " in Your City."),
                                images: item === null || item === void 0 ? void 0 : (ref2 = item.productPictures) === null || ref2 === void 0 ? void 0 : ref2.map(function(img) {
                                    return {
                                        url: img.imageUrl
                                    };
                                }),
                                site_name: "".concat(item === null || item === void 0 ? void 0 : item.name, " | ").concat(title)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_7__/* .ProductJsonLd */ .Qb, {
                            productName: item.name,
                            images: item === null || item === void 0 ? void 0 : (ref3 = item.productPictures) === null || ref3 === void 0 ? void 0 : ref3.map(function(img) {
                                return img.imageUrl;
                            }),
                            description: item.fullDescription,
                            brand: item.brand,
                            offers: [
                                {
                                    price: (item === null || item === void 0 ? void 0 : (ref4 = item.selectedProviderService) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.providerId) === null || ref5 === void 0 ? void 0 : ref5.Price) || item.price,
                                    priceCurrency: "USD"
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_product_product_jsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            renderTransferOverlay: !!this.props.showpriceonly,
                            item: item,
                            symbol: this.props.symbol,
                            addToCart: this.props.addToCart,
                            addToCartUnsafe: this.props.addToCartUnsafe,
                            addToCompare: this.props.addToCompare,
                            addToWishlist: this.props.addToWishlist,
                            applicationLabel: this.props.applicationLabel,
                            applicationProducts: this.props.applicationProducts,
                            crossreferenceid: this.props.crossreferenceid,
                            category: this.props.category,
                            provider: this.props.provider,
                            breadcrumbs: this.props.breadcrumbs,
                            setSelectedProvider: this.props.setSelectedProvider,
                            geolocation: this.props.geolocation,
                            providerLocation: this.props.providerLocation,
                            reviews: this.props.reviews,
                            productIsLoading: this.props.productIsLoading,
                            masterProvider: this.props.masterProvider
                        })
                    ]
                });
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var req = param.req, store = param.store, _query = param.query, productid = _query.productid, crossreferenceid = _query.crossreferenceid, showpriceonly = _query.showpriceonly;
                return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
                    var categoryid, parsedUrl, slug, cityUrl, _query, crit, store_code, initState;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                categoryid = "";
                                showpriceonly = showpriceonly ? showpriceonly : false;
                                if (productid == null) {
                                    parsedUrl = queryString.parseUrl(req.url);
                                    slug = parsedUrl.url.split("/");
                                    cityUrl = null;
                                    if (slug.length >= 3) {
                                        categoryid = slug[2];
                                    }
                                    if (slug.length >= 4) {
                                        // FIXME: cityUrl was missing as variable, what is it used for (V.T. 21.12.2021.)
                                        cityUrl = slug[3];
                                    }
                                    _query = parsedUrl.query, crit = _query.crit, store_code = _query.store_code;
                                }
                                initState = store.getState();
                                return [
                                    4,
                                    store.dispatch((0,_src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .getProduct */ .wv)(productid, showpriceonly))
                                ];
                            case 1:
                                _state.sent();
                                if (crossreferenceid != undefined) {
                                    categoryid = crossreferenceid;
                                }
                                return [
                                    4,
                                    store.dispatch((0,_src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .getCategoryProps */ .tn)(categoryid))
                                ];
                            case 2:
                                _state.sent();
                                if (!store_code) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    store.dispatch((0,_src_redux_actions_providerLocation__WEBPACK_IMPORTED_MODULE_6__/* .setSelectedProviderLocation */ .J2)(store_code, initState.geolocation))
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                return [
                                    2,
                                    {
                                        showpriceonly: showpriceonly,
                                        productid: productid,
                                        crossreferenceid: crossreferenceid
                                    }
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ProductPage;
}(_src_components_page__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z);
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(ProductPage, "propTypes", {
    productId: (prop_types__WEBPACK_IMPORTED_MODULE_17___default().string)
});
var mapStateToProps = function(state) {
    return {
        fitmentTarget: state.category.fitmentTarget,
        geolocation: state.geolocation,
        applicationLabelProduct: state.product.item.applicationLabel,
        item: state.product.item,
        productIsLoading: state.product.isLoading,
        applicationProducts: state.category.products,
        category: state.category,
        applicationBreadcrumbs: state.category.breadcrumbs,
        application: state.category.application,
        applicationLabel: state.category.applicationLabel,
        breadcrumbs: state.category.breadcrumbs,
        provider: state.provider,
        providerLocation: state.providerLocation,
        reviews: state.reviews,
        masterProvider: state.masterProvider
    };
};
var mapDispatchToProps = {
    addToCartUnsafe: _src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .addToCartUnsafe */ .Hn,
    addToCart: _src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .addToCart */ .Xq,
    addToWishlist: _src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .addToWishlist */ .Mp,
    addToCompare: _src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .addToCompare */ .a$,
    getProductData: _src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .getProduct */ .wv,
    getCategoryProps: _src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .getCategoryProps */ .tn,
    setSelectedProvider: _src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setSelectedProvider */ .QV,
    setNavigation: _src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .setNavigation */ .An,
    setSelectedProviderLocation: _src_redux_actions_providerLocation__WEBPACK_IMPORTED_MODULE_6__/* .setSelectedProviderLocation */ .J2,
    setLocation: _src_redux_actions_geolocation__WEBPACK_IMPORTED_MODULE_5__/* .setLocation */ .l6
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_lib_withPage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)((0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(ProductPage)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,1664,5675,1175,6672,7204,7206,8013,3065,8214,5604,9180,1310,1151,4762,5406,949,9723,3366,1874,9174,6088,9232,1495,768,9774,2888,179], function() { return __webpack_exec__(43760); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);